<template>
  <div
    id="app"
    :class="{ isLoggedIn: isLoggedIn, isScrollBlocked: blockScroll }"
  >
    <TheHeader />
    <router-view />
    <TheFooterContact v-show="!(isIkeaClient && $route.name == 'order')"/>
    <TheFooterBar />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import Logger from "./services/LoggerService";
import TheHeader from "@/components/sections/TheHeader.vue";
import TheFooterBar from "@/components/sections/TheFooterBar.vue";
import TheFooterContact from "@/components/sections/TheFooterContact.vue";
import { mapState, mapGetters } from "vuex";

export default defineComponent({
  components: {
    TheHeader,
    TheFooterBar,
    TheFooterContact,
  },

  data() {
    return {
      logger: new Logger("App"),
      supportedLanguages: ['en', 'pl', 'cz', 'de']
    };
  },

  mounted() {
    this.logger.logInformation("Mounting...");
    this.setHtmlLangAttribute();
  },
  watch: {
    '$route.path': {
      handler() {
        this.setHtmlLangAttribute();
      },
    }
  },
  methods: {
    setHtmlLangAttribute() {
      // Get the current path from Vue Router
      const path = this.$route.path;
      const parts = path.split('/');

      let langToSet = 'en';

      // Check if the first segment exists and is one of your supported languages
      if (parts.length > 1 && parts[1]) {
        const langCandidate = parts[1];
        if (this.supportedLanguages.includes(langCandidate)) {
          langToSet = langCandidate;
        }
      }

      // Set the 'lang' attribute on the <html> element
      document.documentElement.setAttribute('lang', langToSet);
    },
  },

  computed: {
    ...mapState(["isLoggedIn", "blockScroll"]),
    ...mapGetters(["isIkeaClient"]),
  },
});
</script>

<style lang="scss">
@import "./scss/style.scss";
</style>
